module.exports = __webpack_public_path__ + "static/media/Motores.93a5a652.png";